import React from 'react';
import styles from 'assets/css/CourseComponent.module.css';
import { StatusCheckmarkInfo } from 'Components/StatusMessage';
import { getImageSource } from 'utils/imgUtils';

function StudyProgramAndCertificationCard(props) {
    const { HeaderText, IsComplete, CourseImageUrl } = props.data;

    let courseImgResolved = getImageSource(CourseImageUrl);

    return (
        <div className={`${styles.wrapper} ${styles.aceU}`}>
            {courseImgResolved && 
            <div className={styles.imgWrap}>
                <img src={courseImgResolved} alt={HeaderText} />
            </div>}
            <div className={styles.contentWrap}>
                <h4 className={styles.courseHeader}>{HeaderText}</h4>
                {IsComplete && <StatusCheckmarkInfo>
                    Completed
                </StatusCheckmarkInfo>}
            </div>
        </div>
    )
}

export default StudyProgramAndCertificationCard;